import axios from "axios";
import { resetUserData, getLoginTokens, setLoginTokens } from "../services/storageService";

export const forceLogout = () => {
	resetUserData();
	window.location.href = "/";
};

export const refreshAccessToken = async (api_url) => {
	try {
		const existing = getLoginTokens();
		const { jawab_refreshToken } = existing;

		if (!jawab_refreshToken) return false;

		const response = await axios.post(`${api_url}/auth/refresh`, {
			refresh: jawab_refreshToken,
		});

		if (response.data?.access) {
			const updated = {
				success: true,
				access: response.data.access,
				refresh: response.data.refresh,
				user: response.data.user || null,
			};
			setLoginTokens(updated);
			return true;
		}
		return false;
	} catch (error) {
		console.error("Failed to refresh token:", error);
		return false;
	}
};
